import React from 'react';
import { Mail, Send, Edit3, FileText, Receipt, DollarSign } from 'lucide-react';
import ModalPortal from '../ModalPortal';
import ConvertirAvoirModal from './ConvertirAvoirModal';

const HistoriqueVenteModals = ({ api, modals }) => {
  const {
    showRetraitModal,
    setShowRetraitModal,
    retraitData,
    setRetraitData,
    handleRetrait,
    emailModal,
    setEmailModal,
    sendingEmail,
    handleSendEmail,
    defEmailModal,
    setDefEmailModal,
    sendingDefEmail,
    handleSendDefEmail,
    paymentModal,
    setPaymentModal,
    savingPayment,
    submitPaymentChange,
    factureDefModal,
    setFactureDefModal,
    completerModal,
    setCompleterModal,
    completerData,
    setCompleterData,
    completingPayment,
    handleCompleterPaiement,
    avoirModal,
    setAvoirModal,
    handleAvoirCreated,
  } = modals;

  return (
    <>
      {showRetraitModal && (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center p-4" style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', zIndex: 9999 }}>
          <div className="modal-dark w-full max-w-md" data-testid="retrait-modal">
            <div className="modal-dark-header flex items-center justify-between">
              <h3 className="font-bold text-lg">Retrait caisse</h3>
              <button type="button" onClick={() => setShowRetraitModal(false)} className="rm-touch text-[var(--rm-gray-400)] hover:text-white">✕</button>
            </div>
            <div className="p-6 space-y-4">
              <div>
                <label className="block text-sm text-[var(--rm-gray-300)] mb-2">Montant (€)</label>
                <input
                  type="number"
                  value={retraitData.montant}
                  onChange={(e) => setRetraitData({ ...retraitData, montant: parseFloat(e.target.value) || 0 })}
                  className="input-dark w-full py-3 min-h-[44px]"
                  step="0.01"
                  min="0"
                  data-testid="retrait-montant-input"
                />
              </div>
              <div>
                <label className="block text-sm text-[var(--rm-gray-300)] mb-2">Motif</label>
                <input
                  type="text"
                  value={retraitData.motif}
                  onChange={(e) => setRetraitData({ ...retraitData, motif: e.target.value })}
                  className="input-dark w-full py-3 min-h-[44px]"
                  data-testid="retrait-motif-input"
                />
              </div>
              <div className="flex gap-3 pt-4">
                <button
                  type="button"
                  onClick={() => setShowRetraitModal(false)}
                  className="flex-1 py-3 min-h-[44px] rounded-xl border font-bold text-[var(--rm-gray-300)] hover:bg-white/5"
                  style={{ borderColor: 'var(--rm-border-subtle)' }}
                >
                  Annuler
                </button>
                <button
                  type="button"
                  onClick={handleRetrait}
                  className="flex-1 py-3 min-h-[44px] rounded-xl btn-accent font-bold"
                  data-testid="retrait-confirm"
                >
                  Valider
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {emailModal.show && (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center p-4" style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', zIndex: 9999 }}>
          <div className="modal-dark w-full max-w-md" data-testid="email-modal">
            <div className="modal-dark-header flex items-center justify-between">
              <h3 className="font-bold text-lg flex items-center gap-2"><Mail className="w-5 h-5 text-[var(--rm-gray-400)]" /> Envoyer facture par email</h3>
              <button type="button" onClick={() => setEmailModal({ show: false, ref: '', email: '' })} className="rm-touch text-[var(--rm-gray-400)] hover:text-white">✕</button>
            </div>
            <div className="p-6 space-y-4">
              <p className="text-sm text-[var(--rm-gray-400)]">Réf: <span className="text-[var(--rm-white)] font-mono">{emailModal.ref}</span></p>
              <div className="rounded-xl border p-3 text-sm space-y-1" style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }}>
                <div className="flex justify-between gap-3">
                  <span className="text-[var(--rm-gray-500)]">Total TTC</span>
                  <span className="font-bold text-[var(--rm-white)]">{(emailModal.total ?? 0).toFixed(2)} €</span>
                </div>
                <div className="flex justify-between gap-3">
                  <span className="text-[var(--rm-gray-500)]">Montant payé</span>
                  <span className="font-bold text-[var(--rm-success)]">{(emailModal.montant_paye ?? emailModal.total ?? 0).toFixed(2)} €</span>
                </div>
                {(emailModal.reste_a_payer || 0) > 0.01 && (
                  <div className="flex justify-between gap-3">
                    <span className="text-[var(--rm-gray-500)]">Reste à payer</span>
                    <span className="font-bold text-[var(--rm-red-light)]">{emailModal.reste_a_payer.toFixed(2)} €</span>
                  </div>
                )}
                {emailModal.mode_paiement && (
                  <div className="flex justify-between gap-3">
                    <span className="text-[var(--rm-gray-500)]">Mode</span>
                    <span className="text-[var(--rm-gray-200)]">{emailModal.mode_paiement}</span>
                  </div>
                )}
              </div>
              <div>
                <label className="block text-sm text-[var(--rm-gray-300)] mb-2">Adresse email</label>
                <input
                  type="email"
                  value={emailModal.email}
                  onChange={(e) => setEmailModal({ ...emailModal, email: e.target.value })}
                  placeholder="client@exemple.com"
                  className="input-dark w-full py-3 min-h-[44px]"
                  data-testid="email-modal-input"
                />
              </div>
              <div className="flex gap-3 pt-4">
                <button
                  type="button"
                  onClick={() => setEmailModal({ show: false, ref: '', email: '' })}
                  className="flex-1 py-3 min-h-[44px] rounded-xl border font-bold text-[var(--rm-gray-300)] hover:bg-white/5"
                  style={{ borderColor: 'var(--rm-border-subtle)' }}
                >
                  Annuler
                </button>
                <button
                  type="button"
                  onClick={handleSendEmail}
                  disabled={sendingEmail || !emailModal.email}
                  className="flex-1 py-3 min-h-[44px] rounded-xl btn-accent font-bold flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
                  data-testid="email-modal-send"
                >
                  {sendingEmail ? (
                    <div className="loading-spinner w-5 h-5" />
                  ) : (
                    <><Send className="w-4 h-4" /> Envoyer</>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {defEmailModal.show && (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center p-4" style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', zIndex: 9999 }}>
          <div className="modal-dark w-full max-w-md" data-testid="def-email-modal">
            <div className="modal-dark-header flex items-center justify-between">
              <h3 className="font-bold text-lg flex items-center gap-2"><Mail className="w-5 h-5 text-[var(--rm-success)]" /> Envoyer facture définitive</h3>
              <button type="button" onClick={() => setDefEmailModal({ show: false, deviceRef: '', email: '' })} className="rm-touch text-[var(--rm-gray-400)] hover:text-white">✕</button>
            </div>
            <div className="p-6 space-y-4">
              <p className="text-sm text-[var(--rm-gray-400)]">Réf appareil: <span className="text-[var(--rm-white)] font-mono">{defEmailModal.deviceRef}</span></p>
              <div>
                <label className="block text-sm text-[var(--rm-gray-300)] mb-2">Adresse email du client</label>
                <input
                  type="email"
                  value={defEmailModal.email}
                  onChange={(e) => setDefEmailModal({ ...defEmailModal, email: e.target.value })}
                  placeholder="client@exemple.com"
                  className="input-dark w-full py-3 min-h-[44px]"
                  data-testid="def-email-modal-input"
                />
              </div>
              <div className="flex gap-3 pt-4">
                <button
                  type="button"
                  onClick={() => setDefEmailModal({ show: false, deviceRef: '', email: '' })}
                  className="flex-1 py-3 min-h-[44px] rounded-xl border font-bold text-[var(--rm-gray-300)] hover:bg-white/5"
                  style={{ borderColor: 'var(--rm-border-subtle)' }}
                >
                  Annuler
                </button>
                <button
                  type="button"
                  onClick={handleSendDefEmail}
                  disabled={sendingDefEmail || !defEmailModal.email}
                  className="flex-1 py-3 min-h-[44px] rounded-xl btn-success font-bold flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
                  data-testid="def-email-modal-send"
                >
                  {sendingDefEmail ? (
                    <div className="loading-spinner w-5 h-5" />
                  ) : (
                    <><Send className="w-4 h-4" /> Envoyer</>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {paymentModal.show && (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center p-4" style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', zIndex: 9999 }}>
          <div className="modal-dark w-full max-w-md" data-testid="payment-modal">
            <div className="modal-dark-header flex items-center justify-between">
              <h3 className="font-bold text-lg flex items-center gap-2"><Edit3 className="w-5 h-5 text-[var(--rm-gray-400)]" /> Modifier le mode de paiement</h3>
              <button type="button" onClick={() => setPaymentModal({ show: false, ref: '', current: '' })} className="rm-touch text-[var(--rm-gray-400)] hover:text-white" data-testid="payment-modal-close">✕</button>
            </div>
            <div className="p-6 space-y-4">
              <p className="text-sm text-[var(--rm-gray-400)]">Réf: <span className="text-[var(--rm-white)] font-mono">{paymentModal.ref}</span></p>
              <div>
                <label className="block text-sm text-[var(--rm-gray-300)] mb-2">Mode de paiement</label>
                <select
                  value={paymentModal.current}
                  onChange={(e) => setPaymentModal({ ...paymentModal, current: e.target.value })}
                  className="input-dark w-full py-3 min-h-[44px]"
                  data-testid="payment-modal-select"
                >
                  <option value="Espèces">Espèces</option>
                  <option value="Carte Bancaire">Carte Bancaire</option>
                  <option value="Virement">Virement</option>
                  <option value="Stripe">Stripe</option>
                  <option value="Mixte">Mixte</option>
                  <option value="Autre">Autre</option>
                </select>
              </div>
              <div className="flex gap-3 pt-4">
                <button
                  type="button"
                  onClick={() => setPaymentModal({ show: false, ref: '', current: '' })}
                  className="flex-1 py-3 min-h-[44px] rounded-xl border font-bold text-[var(--rm-gray-300)] hover:bg-white/5"
                  style={{ borderColor: 'var(--rm-border-subtle)' }}
                  data-testid="payment-modal-cancel"
                >
                  Annuler
                </button>
                <button
                  type="button"
                  onClick={submitPaymentChange}
                  disabled={savingPayment}
                  className="flex-1 py-3 min-h-[44px] rounded-xl btn-accent font-bold flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
                  data-testid="payment-modal-confirm"
                >
                  {savingPayment ? (
                    <div className="loading-spinner w-5 h-5" />
                  ) : (
                    'Valider'
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {factureDefModal.show && (
        <ModalPortal>
          <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50">
            <div className="modal-dark w-full max-w-md mx-4" data-testid="facture-def-modal">
              <div className="modal-dark-header">
                <h3 className="text-lg font-bold">Facture définitive</h3>
              </div>
              <div className="p-6">
                <p className="text-sm text-[var(--rm-gray-400)] mb-5">
                  Réf: <span className="text-[var(--rm-white)] font-mono">{factureDefModal.vente?.ref_vente}</span> — {factureDefModal.vente?.client_nom}
                </p>
                <div className="space-y-3">
                  <button
                    type="button"
                    onClick={() => {
                      const url = window.URL.createObjectURL(factureDefModal.pdfBlob);
                      const a = document.createElement('a');
                      a.href = url;
                      a.download = `facture_definitive_${factureDefModal.vente?.ref_vente || 'doc'}.pdf`;
                      a.click();
                      window.URL.revokeObjectURL(url);
                    }}
                    className="w-full flex items-center gap-3 px-4 py-3 min-h-[44px] rounded-xl border hover:bg-white/5 transition-colors"
                    style={{ borderColor: 'var(--rm-border-subtle)', color: 'var(--rm-success)' }}
                    data-testid="facture-def-download"
                  >
                    <FileText className="w-5 h-5" />
                    <span className="font-semibold">Télécharger le PDF</span>
                  </button>
                  <button
                    type="button"
                    onClick={() => {
                      const url = window.URL.createObjectURL(factureDefModal.pdfBlob);
                      const printWin = window.open(url, '_blank', 'width=900,height=700');
                      if (printWin) printWin.focus();
                      setTimeout(() => window.URL.revokeObjectURL(url), 8000);
                    }}
                    className="w-full flex items-center gap-3 px-4 py-3 min-h-[44px] rounded-xl border hover:bg-white/5 transition-colors"
                    style={{ borderColor: 'var(--rm-border-subtle)', color: 'var(--rm-gray-200)' }}
                    data-testid="facture-def-print"
                  >
                    <Receipt className="w-5 h-5" />
                    <span className="font-semibold">Ouvrir / Imprimer</span>
                  </button>
                  <button
                    type="button"
                    onClick={async () => {
                      const v = factureDefModal.vente;
                      const email = v?.client_email || v?.email || '';
                      if (!email) {
                        alert('Aucun email client associé à cette vente');
                        return;
                      }
                      try {
                        setFactureDefModal((prev) => ({ ...prev, loading: true }));
                        await api.post(`/factures/definitive/${encodeURIComponent(v.device_ref || v.ref_vente)}/email`, { email });
                        alert(`Facture envoyée à ${email}`);
                        setFactureDefModal({ show: false, vente: null, pdfBlob: null, loading: false });
                      } catch (err) {
                        alert(err.response?.data?.detail || 'Erreur envoi email');
                        setFactureDefModal((prev) => ({ ...prev, loading: false }));
                      }
                    }}
                    disabled={factureDefModal.loading}
                    className="w-full flex items-center gap-3 px-4 py-3 min-h-[44px] rounded-xl border hover:bg-white/5 transition-colors disabled:opacity-50"
                    style={{ borderColor: 'var(--rm-border-subtle)', color: 'var(--rm-gray-200)' }}
                    data-testid="facture-def-email"
                  >
                    <Mail className="w-5 h-5" />
                    <span className="font-semibold">
                      {factureDefModal.loading ? 'Envoi…' : 'Envoyer par email'}
                    </span>
                  </button>
                </div>
                <button
                  type="button"
                  onClick={() => setFactureDefModal({ show: false, vente: null, pdfBlob: null, loading: false })}
                  className="w-full mt-4 py-3 min-h-[44px] text-sm text-[var(--rm-gray-500)] hover:text-white transition-colors"
                >
                  Fermer
                </button>
              </div>
            </div>
          </div>
        </ModalPortal>
      )}

      {completerModal.show && completerModal.vente && (
        <ModalPortal>
          <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/70" onClick={() => setCompleterModal({ show: false, vente: null })}>
            <div
              className="modal-dark w-full max-w-md mx-4"
              onClick={(e) => e.stopPropagation()}
              data-testid="completer-paiement-modal"
            >
              <div className="modal-dark-header">
                <h3 className="text-lg font-bold">Compléter le paiement</h3>
              </div>
              <div className="p-6">
                <p className="text-sm text-[var(--rm-gray-400)] mb-1">
                  Réf: <span className="text-[var(--rm-white)] font-mono">{completerModal.vente.ref_vente}</span>
                </p>
                <div className="flex flex-wrap justify-between gap-2 text-sm mb-4 p-3 rounded-xl border" style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }}>
                  <div><span className="text-[var(--rm-gray-500)]">Total:</span> <span className="font-bold text-[var(--rm-white)]">{(completerModal.vente.prix_total || 0).toFixed(2)} €</span></div>
                  <div><span className="text-[var(--rm-gray-500)]">Payé:</span> <span className="font-bold text-[var(--rm-success)]">{(completerModal.vente.montant_paye || 0).toFixed(2)} €</span></div>
                  <div><span className="text-[var(--rm-gray-500)]">Reste:</span> <span className="font-bold text-[var(--rm-red-light)]">{(completerModal.vente.reste_a_payer || 0).toFixed(2)} €</span></div>
                </div>

                {completerModal.vente.items?.length > 0 && (
                  <div className="mb-4 max-h-32 overflow-y-auto rounded-lg p-2 border" style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }}>
                    {completerModal.vente.items.map((it, i) => (
                      <div key={i} className="flex justify-between text-xs text-[var(--rm-gray-400)] py-0.5">
                        <span>{it.designation} x{it.quantite}</span>
                        <span>{(it.prix_total || 0).toFixed(2)} €</span>
                      </div>
                    ))}
                  </div>
                )}

                <div className="space-y-3">
                  <div>
                    <label className="text-xs text-[var(--rm-gray-500)] mb-1 block">Mode de paiement</label>
                    <div className="flex gap-2">
                      {['Espèces', 'Carte Bancaire', 'Mixte'].map((m) => (
                        <button
                          key={m}
                          type="button"
                          onClick={() => {
                            setCompleterData({
                              ...completerData,
                              mode_paiement: m,
                              paiement_especes: m === 'Espèces' ? String(completerModal.vente.reste_a_payer || 0) : '',
                              paiement_cb: m === 'Carte Bancaire' ? String(completerModal.vente.reste_a_payer || 0) : '',
                            });
                          }}
                          className={`flex-1 py-3 min-h-[44px] rounded-xl text-xs font-bold border transition-colors ${
                            completerData.mode_paiement === m
                              ? 'text-[var(--rm-white)]'
                              : 'text-[var(--rm-gray-400)] hover:bg-white/5'
                          }`}
                          style={{
                            borderColor: completerData.mode_paiement === m ? 'var(--rm-red)' : 'var(--rm-border-subtle)',
                            background: completerData.mode_paiement === m ? 'var(--rm-red-muted)' : 'var(--rm-bg-panel)',
                          }}
                          data-testid={`completer-mode-${m}`}
                        >
                          {m === 'Carte Bancaire' ? 'CB' : m}
                        </button>
                      ))}
                    </div>
                  </div>

                  {(completerData.mode_paiement === 'Espèces' || completerData.mode_paiement === 'Mixte') && (
                    <div>
                      <label className="text-xs text-[var(--rm-gray-500)] mb-1 block">Espèces (€)</label>
                      <input
                        type="number"
                        step="0.01"
                        value={completerData.paiement_especes}
                        onChange={(e) => setCompleterData({ ...completerData, paiement_especes: e.target.value })}
                        className="input-dark w-full py-3 min-h-[44px]"
                        data-testid="completer-especes"
                      />
                    </div>
                  )}
                  {(completerData.mode_paiement === 'Carte Bancaire' || completerData.mode_paiement === 'Mixte') && (
                    <div>
                      <label className="text-xs text-[var(--rm-gray-500)] mb-1 block">Carte Bancaire (€)</label>
                      <input
                        type="number"
                        step="0.01"
                        value={completerData.paiement_cb}
                        onChange={(e) => setCompleterData({ ...completerData, paiement_cb: e.target.value })}
                        className="input-dark w-full py-3 min-h-[44px]"
                        data-testid="completer-cb"
                      />
                    </div>
                  )}

                  <div className="flex gap-3 mt-4">
                    <button
                      type="button"
                      onClick={() => setCompleterModal({ show: false, vente: null })}
                      className="flex-1 py-3 min-h-[44px] rounded-xl border font-semibold text-sm text-[var(--rm-gray-400)] hover:bg-white/5"
                      style={{ borderColor: 'var(--rm-border-subtle)' }}
                    >
                      Annuler
                    </button>
                    <button
                      type="button"
                      onClick={handleCompleterPaiement}
                      disabled={completingPayment}
                      className="flex-1 py-3 min-h-[44px] rounded-xl btn-accent font-bold text-sm disabled:opacity-50 flex items-center justify-center gap-2"
                      data-testid="completer-valider-btn"
                    >
                      {completingPayment ? <div className="loading-spinner w-4 h-4" /> : <DollarSign className="w-4 h-4" />}
                      Encaisser
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ModalPortal>
      )}
      <ConvertirAvoirModal
        open={Boolean(avoirModal?.show)}
        vente={avoirModal?.vente}
        api={api}
        onClose={() => setAvoirModal?.({ show: false, vente: null })}
        onCreated={handleAvoirCreated}
      />
    </>
  );
};

export default HistoriqueVenteModals;
